import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const PartDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ partId: string }>();

  useEffect(() => {
    if (match.isExact) {
      const { partId } = match.params;

      history.replace(`/app/operational/inventory/parts/${partId}/general`);
    }
  }, [match]);

  return null;
};

export default PartDetailsPage;
